// extracted by mini-css-extract-plugin
export default {"select_tag":"newpagination_select_tag__gqJTO","btn1":"newpagination_btn1__tiADI","btn2":"newpagination_btn2__cZH-S"};